var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      {
        attrs: { "data-vv-scope": "form" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
          },
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return (() => {}).apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h4", { staticClass: "font-weight-normal" }, [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(_vm.$t(`global.settings.map.title`)) +
                  "\n\t\t\t\t"
              ),
            ]),
            _vm._v(" "),
            _c("hr", { staticClass: "mt-2" }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "MaterialSelect",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: true, regex: /^EPSG:\d+$/i },
                      expression: "{ required: true, regex: /^EPSG:\\d+$/i }",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    disabled: _vm.readonlyFormItem,
                    id: "input-crs",
                    name: "crs",
                    label: "name",
                    filterable: true,
                    options: _vm.availableCrs,
                    reduce: (option) => option.name,
                    inputClasses: [{ "is-invalid": _vm.fnHasError("crs") }],
                    error: _vm.fnFirstError("crs"),
                    helpText: _vm.help.crs,
                  },
                  model: {
                    value: _vm.form.crs.epsg,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form.crs,
                        "epsg",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.crs.epsg",
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.$t(`global.settings.map.crs.name`)) +
                      "\n\t\t\t\t"
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _c("h6", { staticClass: "font-weight-normal" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t\t" +
                      _vm._s(_vm.$t(`global.settings.map.crs.available`)) +
                      "\n\t\t\t\t\t\t"
                  ),
                ]),
                _vm._v(" "),
                _c("hr", { staticClass: "mt-2" }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-3" }, [
              _c("section", { staticClass: "mb-3" }, [
                _c(
                  "ul",
                  { staticClass: "list-group" },
                  _vm._l(_vm.form.projections, function (item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "list-group-item py-1 px-3",
                        class: { disabled: _vm.readonlyFormItem },
                        attrs: { id: index },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-row justify-content-between align-items-center",
                          },
                          [
                            _c("span", [_vm._v(_vm._s(item.name))]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.epsg))]),
                            _vm._v(" "),
                            !_vm.readonlyFormItem
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-delete min-w-auto m-0 px-2 py-1",
                                    attrs: {
                                      "data-toggle": "tooltip-city",
                                      title: _vm.$t(`global.remove`),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeProjection(index)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "far fa-trash-alt" })]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group city-form-group mb-0" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.projections,
                        expression: "form.projections",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: { type: "hidden", name: "projections" },
                    domProps: { value: _vm.form.projections },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, "projections", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "small",
                    {
                      staticClass: "invalid-feedback",
                      class: { "d-block": _vm.fnHasError("projections") },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\t" +
                          _vm._s(_vm.fnFirstError("projections")) +
                          "\n\t\t\t\t\t\t\t"
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              !_vm.readonlyFormItem
                ? _c("section", [
                    _c(
                      "form",
                      {
                        staticClass: "w-100",
                        attrs: { "data-vv-scope": "new-projection" },
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.addProjection.apply(null, arguments)
                          },
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                            return _vm.addProjection.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "input-group" },
                          [
                            _c(
                              "MaterialInput",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                staticClass:
                                  "city-form-group city-bg col m-0 p-0",
                                attrs: {
                                  readonly: _vm.readonlyFormItem,
                                  disabled: _vm.readonlyFormItem,
                                  type: "text",
                                  id: "input-projection-name",
                                  name: "projection-name",
                                  inputClasses: [
                                    {
                                      "is-invalid": _vm.fnHasError(
                                        "projection-name",
                                        "new-projection"
                                      ),
                                    },
                                  ],
                                  error: _vm.fnFirstError(
                                    "projection-name",
                                    "new-projection"
                                  ),
                                },
                                model: {
                                  value: _vm.newProjection.name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.newProjection,
                                      "name",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "newProjection.name",
                                },
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        `global.settings.map.projection.name`
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "MaterialInput",
                              {
                                directives: [
                                  { name: "uppercase", rawName: "v-uppercase" },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: true,
                                      regex: /^EPSG:\d+$/i,
                                    },
                                    expression:
                                      "{ required: true, regex: /^EPSG:\\d+$/i }",
                                  },
                                ],
                                staticClass:
                                  "city-form-group city-bg col m-0 p-0",
                                attrs: {
                                  readonly: _vm.readonlyFormItem,
                                  disabled: _vm.readonlyFormItem,
                                  type: "text",
                                  id: "input-projection-epsg",
                                  name: "projection-epsg",
                                  inputClasses: [
                                    {
                                      "is-invalid": _vm.fnHasError(
                                        "projection-epsg",
                                        "new-projection"
                                      ),
                                    },
                                  ],
                                  error: _vm.fnFirstError(
                                    "projection-epsg",
                                    "new-projection"
                                  ),
                                },
                                model: {
                                  value: _vm.newProjection.epsg,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.newProjection,
                                      "epsg",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "newProjection.epsg",
                                },
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        `global.settings.map.projection.epsg`
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._m(0),
                          ],
                          1
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _c("h6", { staticClass: "font-weight-normal" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t\t" +
                      _vm._s(_vm.$t(`global.settings.resolutions.title`)) +
                      "\n\t\t\t\t\t\t"
                  ),
                ]),
                _vm._v(" "),
                _c("hr", { staticClass: "mt-2" }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-3" }, [
              _c("section", { staticClass: "mb-3" }, [
                _c(
                  "ul",
                  { staticClass: "list-group" },
                  _vm._l(_vm.form.resolutions, function (item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "list-group-item py-1 px-3",
                        class: { disabled: _vm.readonlyFormItem },
                        attrs: { id: index },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-row justify-content-between align-items-center",
                          },
                          [
                            _c("span", [_vm._v(_vm._s(item))]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.scale(item)))]),
                            _vm._v(" "),
                            !_vm.readonlyFormItem
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-delete min-w-auto m-0 px-2",
                                    attrs: {
                                      "data-toggle": "tooltip-city",
                                      title: "Remover",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeResolution(index)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "far fa-trash-alt" })]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group city-form-group mb-0" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.resolutions,
                        expression: "form.resolutions",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: { type: "hidden", name: "resolutions" },
                    domProps: { value: _vm.form.resolutions },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, "resolutions", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "small",
                    {
                      staticClass: "invalid-feedback",
                      class: { "d-block": _vm.fnHasError("resolutions") },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\t\t" +
                          _vm._s(_vm.fnFirstError("resolutions")) +
                          "\n\t\t\t\t\t\t\t\t"
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              !_vm.readonlyFormItem
                ? _c("section", [
                    _c(
                      "form",
                      {
                        staticClass: "w-100",
                        attrs: { "data-vv-scope": "new-resolution" },
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.addResolution.apply(null, arguments)
                          },
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                            return _vm.addResolution.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "input-group" },
                          [
                            _c(
                              "MaterialInput",
                              {
                                directives: [
                                  { name: "decimal", rawName: "v-decimal" },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|decimal",
                                    expression: "'required|decimal'",
                                  },
                                ],
                                staticClass:
                                  "city-form-group city-bg col m-0 p-0",
                                attrs: {
                                  readonly: _vm.readonlyFormItem,
                                  disabled: _vm.readonlyFormItem,
                                  type: "text",
                                  id: "input-resolution-name",
                                  name: "resolution-name",
                                  inputClasses: [
                                    {
                                      "is-invalid": _vm.fnHasError(
                                        "resolution-name",
                                        "new-resolution"
                                      ),
                                    },
                                  ],
                                  error: _vm.fnFirstError(
                                    "resolution-name",
                                    "new-resolution"
                                  ),
                                },
                                model: {
                                  value: _vm.newResolution,
                                  callback: function ($$v) {
                                    _vm.newResolution =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "newResolution",
                                },
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(`global.settings.resolutions.name`)
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._m(1),
                          ],
                          1
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _c("h6", { staticClass: "font-weight-normal" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t\t" +
                      _vm._s(_vm.$t(`global.settings.scales.title`)) +
                      "\n\t\t\t\t\t\t"
                  ),
                ]),
                _vm._v(" "),
                _c("hr", { staticClass: "mt-2" }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 col-sm-4" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        { name: "decimal", rawName: "v-decimal" },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|decimal",
                          expression: "'required|decimal'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        disabled: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-center-lon",
                        name: "center-lon",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("center-lon") },
                        ],
                        error: _vm.fnFirstError("center-lon"),
                      },
                      model: {
                        value: _vm.form.center.x,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.center,
                            "x",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.center.x",
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(_vm.$t(`global.settings.scales.center.lon`)) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-sm-4" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        { name: "decimal", rawName: "v-decimal" },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|decimal",
                          expression: "'required|decimal'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        disabled: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-center-lat",
                        name: "center-lat",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("center-lat") },
                        ],
                        error: _vm.fnFirstError("center-lat"),
                      },
                      model: {
                        value: _vm.form.center.y,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.center,
                            "y",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.center.y",
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(_vm.$t(`global.settings.scales.center.lat`)) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-sm-4" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        { name: "decimal", rawName: "v-decimal" },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|decimal",
                          expression: "'required|decimal'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        disabled: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-scale",
                        name: "scale",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("scale") },
                        ],
                        error: _vm.fnFirstError("scale"),
                      },
                      model: {
                        value: _vm.form.scale,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "scale",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.scale",
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(_vm.$t(`global.settings.scales.name`)) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _c("h6", { staticClass: "font-weight-normal" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t\t" +
                      _vm._s(_vm.$t(`global.settings.extent.title`)) +
                      "\n\t\t\t\t\t\t"
                  ),
                ]),
                _vm._v(" "),
                _c("hr", { staticClass: "mt-2" }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 col-sm-3" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        { name: "decimal", rawName: "v-decimal" },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|decimal",
                          expression: "'required|decimal'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        disabled: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-extent-minx",
                        name: "extent-minx",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("extent-minx") },
                        ],
                        error: _vm.fnFirstError("extent-minx"),
                      },
                      model: {
                        value: _vm.form.extent.minX,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.extent,
                            "minX",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.extent.minX",
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(_vm.$t(`global.settings.extent.minx`)) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-sm-3" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        { name: "decimal", rawName: "v-decimal" },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|decimal",
                          expression: "'required|decimal'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        disabled: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-extent-miny",
                        name: "extent-miny",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("extent-miny") },
                        ],
                        error: _vm.fnFirstError("extent-miny"),
                      },
                      model: {
                        value: _vm.form.extent.minY,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.extent,
                            "minY",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.extent.minY",
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(_vm.$t(`global.settings.extent.miny`)) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-sm-3" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        { name: "decimal", rawName: "v-decimal" },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {
                            required: true,
                            decimal: true,
                            min_value: _vm.form.extent.minX,
                          },
                          expression:
                            "{required: true, decimal: true, min_value: form.extent.minX}",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        disabled: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-extent-maxx",
                        name: "extent-maxx",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("extent-maxx") },
                        ],
                        error: _vm.fnFirstError("extent-maxx"),
                      },
                      model: {
                        value: _vm.form.extent.maxX,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.extent,
                            "maxX",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.extent.maxX",
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(_vm.$t(`global.settings.extent.maxx`)) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-sm-3" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        { name: "decimal", rawName: "v-decimal" },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {
                            required: true,
                            decimal: true,
                            min_value: _vm.form.extent.minY,
                          },
                          expression:
                            "{required: true, decimal: true, min_value: form.extent.minY}",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        disabled: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-extent-maxx",
                        name: "extent-maxy",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("extent-maxy") },
                        ],
                        error: _vm.fnFirstError("extent-maxy"),
                      },
                      model: {
                        value: _vm.form.extent.maxY,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.extent,
                            "maxY",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.extent.maxY",
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(_vm.$t(`global.settings.extent.maxy`)) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 col-sm-12" }, [
                _c(
                  "div",
                  { staticClass: "form-group city-form-group" },
                  [_c("help-span", { attrs: { helpText: _vm.help.extent } })],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _c("h6", { staticClass: "font-weight-normal" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t\t" +
                      _vm._s(_vm.$t(`global.settings.initial-extent.title`)) +
                      "\n\t\t\t\t\t\t"
                  ),
                ]),
                _vm._v(" "),
                _c("hr", { staticClass: "mt-2" }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 col-sm-3" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        { name: "decimal", rawName: "v-decimal" },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|decimal",
                          expression: "'required|decimal'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        disabled: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-initial-extent-minx",
                        name: "initial-extent-minx",
                        inputClasses: [
                          {
                            "is-invalid": _vm.fnHasError("initial-extent-minx"),
                          },
                        ],
                        error: _vm.fnFirstError("initial-extent-minx"),
                      },
                      model: {
                        value: _vm.form.initial_extent.minX,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.initial_extent,
                            "minX",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.initial_extent.minX",
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t(`global.settings.initial-extent.minx`)
                          ) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-sm-3" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        { name: "decimal", rawName: "v-decimal" },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|decimal",
                          expression: "'required|decimal'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        disabled: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-initial-extent-miny",
                        name: "initial-extent-miny",
                        inputClasses: [
                          {
                            "is-invalid": _vm.fnHasError("initial-extent-miny"),
                          },
                        ],
                        error: _vm.fnFirstError("initial-extent-miny"),
                      },
                      model: {
                        value: _vm.form.initial_extent.minY,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.initial_extent,
                            "minY",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.initial_extent.minY",
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t(`global.settings.initial-extent.miny`)
                          ) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-sm-3" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        { name: "decimal", rawName: "v-decimal" },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {
                            required: true,
                            decimal: true,
                            min_value: _vm.form.initial_extent.minX,
                          },
                          expression:
                            "{required: true, decimal: true, min_value: form.initial_extent.minX}",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        disabled: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-initial-extent-maxx",
                        name: "initial-extent-maxx",
                        inputClasses: [
                          {
                            "is-invalid": _vm.fnHasError("initial-extent-maxx"),
                          },
                        ],
                        error: _vm.fnFirstError("initial-extent-maxx"),
                      },
                      model: {
                        value: _vm.form.initial_extent.maxX,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.initial_extent,
                            "maxX",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.initial_extent.maxX",
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t(`global.settings.initial-extent.maxx`)
                          ) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-sm-3" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        { name: "decimal", rawName: "v-decimal" },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {
                            required: true,
                            decimal: true,
                            min_value: _vm.form.initial_extent.minY,
                          },
                          expression:
                            "{required: true, decimal: true, min_value: form.initial_extent.minY}",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        disabled: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-initial-extent-maxy",
                        name: "initial-extent-maxy",
                        inputClasses: [
                          {
                            "is-invalid": _vm.fnHasError("initial-extent-maxy"),
                          },
                        ],
                        error: _vm.fnFirstError("initial-extent-maxy"),
                      },
                      model: {
                        value: _vm.form.initial_extent.maxY,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form.initial_extent,
                            "maxY",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.initial_extent.maxY",
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t(`global.settings.initial-extent.maxy`)
                          ) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 col-sm-12" }, [
                _c(
                  "div",
                  { staticClass: "form-group city-form-group" },
                  [
                    _c("help-span", {
                      attrs: { helpText: _vm.help.initial_extent },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _c("h6", { staticClass: "font-weight-normal" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t\t" +
                      _vm._s(_vm.$t(`global.settings.boundary.title`)) +
                      "\n\t\t\t\t\t\t"
                  ),
                ]),
                _vm._v(" "),
                _c("hr", { staticClass: "mt-2" }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "form-group city-form-group city-bg mb-0" },
                  [
                    _c(
                      "MaterialTextarea",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "geometryFeature",
                            expression: "'geometryFeature'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.readonlyFormItem,
                          disabled: _vm.readonlyFormItem,
                          id: "input-boundary",
                          name: "boundary",
                          rows: 6,
                          helpText: _vm.help.boundary,
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("boundary") },
                          ],
                          error: _vm.fnFirstError("boundary"),
                        },
                        model: {
                          value: _vm.form.boundary,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "boundary",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.boundary",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t" +
                            _vm._s(_vm.$t(`global.settings.boundary.name`)) +
                            "\n\t\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btn-sm btn-main min-w-auto m-0 border-left-radius-0",
        attrs: {
          "data-toggle": "tooltip-city",
          title: "Adicionar Sistema de Coordenadas",
          type: "submit",
        },
      },
      [_c("i", { staticClass: "fas fa-plus" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btn-sm btn-main min-w-auto m-0 border-left-radius-0",
        attrs: {
          "data-toggle": "tooltip-city",
          title: "Adicionar Resolução",
          type: "submit",
        },
      },
      [_c("i", { staticClass: "fas fa-plus" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }